import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import SchemaIcon from '@mui/icons-material/Schema';
import { IconButton, Link, Stack, Tooltip } from '@mui/material';
import { useNavigate } from "react-router-dom";

import Service from '../../../util/Service';
import { Delete } from '@mui/icons-material';
import ConfirmDialog from '../../common/ConfirmDialog';

export default function SolicitacoesManagerPanel(){
    const [lista, setLista] = React.useState();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [processo, setProcesso] = React.useState();

    React.useEffect(()=>{
      buscaTudo();
    }, [])
    
    function buscaTudo(){
      Service.GET("/api/security/userTask/buscaTodos").then( r =>{
        console.log( r );
          setLista(r);
      })
    }

    function handleDeleteClick(){
      if( processo.bg){
        Service.GET("/api/security/backGround/remove/"+processo.bg.id).then( r =>{
          buscaTudo();
        })
      }else{
        Service.GET("/api/security/userTask/remove/"+processo.ut.id).then( r =>{
          buscaTudo();
        })
      }
    }

    function handleSetProcesso(row){
      console.log( row);
      setOpen(true);
      setProcesso(row);
    }

    const download = (a) => {    
        const url = "/api/bpmn/download/"+a.id;
        fetch(url).then((response) => {
            response.blob().then((blob) => {
            
                // Creating new object of PDF file
                const fileURL =
                    window.URL.createObjectURL(blob);
                    
                // Setting various property values
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = a.nome;
                alink.click();
            });
        });
    };
    function montaAnexos(row){

        return (
            <Stack>
                {row.anexos && row.anexos.map((a) => 
                <Link key={a.id} href="#" onClick={ () => download(a) }>{a.nome}</Link>)
                }
            </Stack>
        );
    }
    function formataData(sdt){
      if (!sdt) return '';
      console.log( sdt );
      const dt = new Date(sdt);

      return dt.toLocaleDateString()+" "+dt.toLocaleTimeString();
    }

    function montaStatus(row){
      let ret = "";
      if( row.ut.status ===  "DONE"){
        if( row.bg.status === "NONE"){
          ret = "Em Fluxo"
        }else if( row.bg.status === "NONE"){
          ret = "Existe um erro";
        }else if( row.bg.status === "DONE"){
          ret = "Processo concluido";
        }else{
          ret = "Status inesperado: ["+row.bg.status+"]";
        }
      }else{
        ret = "Aguardando processo"
      }

      return ret;
    }

    return (
        <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Anexos</TableCell>
            <TableCell>Data</TableCell>
            <TableCell align="right">Conf</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lista && lista.map((row) => (
            <TableRow
              key={row.ut.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.ut.nome}
              </TableCell>
              <TableCell component="th" scope="row">
                { montaStatus(row)}
              </TableCell>
              <TableCell >{
                montaAnexos(row.ut)
              }</TableCell>

              <TableCell >{
                formataData(row.ut.dtCriacao)
              }</TableCell>
              
              <TableCell align="right">
                <IconButton aria-label="edit" onClick={ (() => navigate('../flow/'+row.ut.id))} >
                    <SchemaIcon />
                </IconButton>
                <Tooltip title="Remover Solicitação">
                  <IconButton aria-label="edit" onClick={e=> handleSetProcesso( row)} >
                      <Delete />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {processo && <ConfirmDialog
          open={open}
          setOpen={setOpen}
          ok='Excluir'
          cancel="Sair"
          title={"Remover Solicitação de "+processo.ut.nome}
          body={"Será removido permanentemente a solicitação do  "+processo.ut.userData.nome}
          execute={handleDeleteClick}
      />}
    </TableContainer>
    )
}